import { render, staticRenderFns } from "./AddLabelActionDescription.vue?vue&type=template&id=587359b1&"
import script from "./AddLabelActionDescription.vue?vue&type=script&lang=js&"
export * from "./AddLabelActionDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports